import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../components/Header/Header';
import HeaderSecond from '../components/Header/HeaderSecond';
import Footer from '../components/Footer/Footer';
import FooterSecond from '../components/Footer/FooterSecond';
import '../styles/layouts/_mainLayout.scss';

function MainLayout({ children, customHeader, customFooter }) {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const HeaderComponent = customHeader || (isHomePage ? Header : HeaderSecond);
  const FooterComponent = customFooter || (isHomePage ? Footer : FooterSecond);

  return (
    <div className="main-layout">
      <HeaderComponent />
      <main className="main-content mt-3">
        <div className="container">
          {children}
        </div>
     
      </main>
      <FooterComponent />
    </div>
  );
}

export default MainLayout;
